import { useState } from 'react';
import { transcribeYouTube } from '../services/api';

export const useTranscribe = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const transcribe = async (url: string) => {
    setIsLoading(true);
    setError(null);
    
    try {
      const { data } = await transcribeYouTube(url);
      return data.transcript;
    } catch (err) {
      // If err is a string, it's our custom network error message
      const errorMessage = typeof err === 'string' 
        ? err 
        : (err instanceof Error ? err.message : 'Failed to transcribe video');
      
      setError(errorMessage);
      throw errorMessage;
    } finally {
      setIsLoading(false);
    }
  };

  return { transcribe, isLoading, error };
};
